var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "27px",
    viewBox: "0 0 7 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D5B6EC3D-AA6C-404E-911D-D8E0F3F80E3E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supervisor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Created-Stage-Actions",
    transform: "translate(-1238.000000, -519.000000)",
    fill: "#F7B500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(175.232813, 513.125000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1066.12778,26.887348 C1067.65606,26.887348 1068.89497,28.12626 1068.89497,29.6545355 C1068.89497,31.182811 1067.65606,32.421723 1066.12778,32.421723 C1064.59951,32.421723 1063.36059,31.182811 1063.36059,29.6545355 C1063.36059,28.12626 1064.59951,26.887348 1066.12778,26.887348 Z M1066.12778,16.7328125 C1067.65606,16.7328125 1068.89497,17.9717245 1068.89497,19.5 C1068.89497,21.0282755 1067.65606,22.2671875 1066.12778,22.2671875 C1064.59951,22.2671875 1063.36059,21.0282755 1063.36059,19.5 C1063.36059,17.9717245 1064.59951,16.7328125 1066.12778,16.7328125 Z M1066.12778,6.578277 C1067.65606,6.578277 1068.89497,7.81718904 1068.89497,9.3454645 C1068.89497,10.87374 1067.65606,12.112652 1066.12778,12.112652 C1064.59951,12.112652 1063.36059,10.87374 1063.36059,9.3454645 C1063.36059,7.81718904 1064.59951,6.578277 1066.12778,6.578277 Z",
    id: "Selected-Stage-Menu"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSelected);
export default __webpack_public_path__ + "static/media/menu-selected.249465e751da260f3e76e47fa00c9418.svg";
export { ForwardRef as ReactComponent };